// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import AssessmentPreview from "./Pages/AssessmentPreview";
import PreviewPage from "./Pages/PreviewPage";
import "./App.css";
import Dashboard from "./Pages/Dashboard";
import Posts from "./Pages/Posts";
import LoginPage from "./Components/LoginPage";
import ViewAttempts from "./Pages/ViewAttempts";
import Register from "./Components/Register";
import AssessmentsPage from "./Pages/AssessmentsPage";
import AttemptPage from "./Pages/AttemptPage";
import ExamMcqPage from "./Pages/ExamMcqPage";
import ExamResult from "./Components/ExamResult";
import PreviousExamMcqPage from "./Pages/PreviousExamMcqPage";
import Analytics from "./Pages/Analytics";
import LearnerPracticePage from "./Pages/LearnerPracticePage";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/assessment" element={<AssessmentPreview />} />
        <Route path="/preview" element={<PreviewPage />} />
        <Route path="/posts" element={<Posts />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/attempt" element={<ViewAttempts />} />
        <Route path="/register" element={<Register />} />
        <Route path="/assessmentpage" element={<AssessmentsPage />} />
        <Route path="/attemptpage" element={<AttemptPage />} />
        <Route path="/exammcq" element={<ExamMcqPage />} />
        <Route path="/previousexammcq" element={<PreviousExamMcqPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/examresult" element={<ExamResult />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/learnerpractice" element={<LearnerPracticePage />} />
      </Routes>
    </>
  );
}

export default App;
